import { TEspRequestStatus } from '../model/types'

/** Every status a request can hold, in lifecycle order. */
export const ESP_REQUEST_STATUSES: TEspRequestStatus[] = ['pending', 'approved', 'rejected']

/**
 * Toggles one status in the approval-queue filter.
 *
 * Selecting every status filters nothing out — exactly what an empty selection already
 * means — so completing the set clears it instead of leaving a state that looks
 * unfiltered but behaves like a full selection (where the next click would *remove* a
 * status rather than start a fresh one).
 */
export const toggleEspStatusFilter = (
  current: TEspRequestStatus[],
  status: TEspRequestStatus
): TEspRequestStatus[] => {
  if (current.includes(status)) {
    return current.filter((item) => item !== status)
  }

  const next = [...current, status]

  return next.length === ESP_REQUEST_STATUSES.length ? [] : next
}
